import * as React from "react"
const SvgPages = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 22.857q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20.857v-9q0-.825.587-1.412A1.93 1.93 0 0 1 4 9.857h2v-5q0-.824.588-1.412A1.93 1.93 0 0 1 8 2.857h12q.824 0 1.413.588.587.587.587 1.412v9a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587h-2v5a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-2h12v-7H4zm14-7h2v-7H8v3h8q.824 0 1.413.588.587.587.587 1.412z" />
  </svg>
)
export default SvgPages
